"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionService = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var page_state_1 = require("../state/page.state");
var store_1 = require("../store");
var index_1 = require("./index");
var CollectionService = /** @class */ (function () {
    function CollectionService() {
        this.__priority = 100;
    }
    CollectionService.prototype.getFirstCaptureId = function (collection) {
        if (collection == null) {
            return null;
        }
        var captureIds = this.getCaptureIds(collection);
        return captureIds[0];
    };
    CollectionService.prototype.getCaptureIds = function (collection) {
        var captureIds = [];
        collection.forEachField(function (collectionField) {
            if (core_shared_1.CollectionModelFieldTrueSize.isTrueSizeField(collectionField) || core_shared_1.CollectionModelFieldImage.isImageField(collectionField)) {
                for (var _i = 0, _a = collectionField.getCaptures(); _i < _a.length; _i++) {
                    var capture = _a[_i];
                    captureIds.push(capture.objectId);
                }
            }
            return true;
        });
        return captureIds;
    };
    CollectionService.prototype.remove = function (collectionSummaries) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var allUuids, tagIds, startTime, uuidBatches, _i, uuidBatches_1, uuids, label, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (index_1.Services.Department.current == null) {
                            throw new Error('Cannot delete collections without a current department');
                        }
                        allUuids = collectionSummaries.map(function (c) { return c.uuid; });
                        tagIds = this.getTagIds(collectionSummaries);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        startTime = Date.now();
                        uuidBatches = core_shared_1.IkeArray.chunk(allUuids, CollectionService.BATCH_SIZE);
                        _i = 0, uuidBatches_1 = uuidBatches;
                        _a.label = 2;
                    case 2:
                        if (!(_i < uuidBatches_1.length)) return [3 /*break*/, 5];
                        uuids = uuidBatches_1[_i];
                        return [4 /*yield*/, index_1.Services.Department.rest.Collection.delete({ uuids: uuids })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [4 /*yield*/, index_1.Services.Tag.refresh(tagIds)];
                    case 6:
                        _a.sent();
                        page_state_1.CurrentState.Tag.reset();
                        page_state_1.CurrentState.setInspectedCollection(null);
                        label = "Tags: ".concat(tagIds.length, ", Collections: ").concat(collectionSummaries.length);
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.BigMap, 'COLLECTION_DELETE', label, Date.now() - startTime);
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _a.sent();
                        (0, index_1.handleGenericError)(e_1);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    CollectionService.prototype.duplicate = function (collectionSummaries, tagName, toDepartmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentDepartment, toDepartment, allSelectors, tagIds, startTime, selectorBatches, _i, selectorBatches_1, selectors, label, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentDepartment = index_1.Services.Department.current;
                        if (currentDepartment == null) {
                            throw new Error('Cannot duplicate collections without a current department');
                        }
                        if (!(toDepartmentId != null && toDepartmentId !== currentDepartment.objectId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, index_1.Services.Department.departments.find(function (d) { return d.objectId === toDepartmentId; })];
                    case 1:
                        toDepartment = _a.sent();
                        if (toDepartment == null) {
                            throw new Error('Cannot duplicate collections without a destination department');
                        }
                        _a.label = 2;
                    case 2:
                        allSelectors = collectionSummaries.map(function (summary) { return ({ uuid: summary.uuid }); });
                        tagIds = this.getTagIds(collectionSummaries);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 9, , 10]);
                        startTime = Date.now();
                        selectorBatches = core_shared_1.IkeArray.chunk(allSelectors, CollectionService.BATCH_SIZE);
                        _i = 0, selectorBatches_1 = selectorBatches;
                        _a.label = 4;
                    case 4:
                        if (!(_i < selectorBatches_1.length)) return [3 /*break*/, 7];
                        selectors = selectorBatches_1[_i];
                        return [4 /*yield*/, index_1.Services.Department.rest.Collection.duplicate({ collections: selectors, tagName: tagName, toDepartmentId: toDepartmentId })];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 4];
                    case 7: return [4 /*yield*/, index_1.Services.Tag.refresh(tagIds)];
                    case 8:
                        _a.sent();
                        page_state_1.CurrentState.Tag.reset();
                        page_state_1.CurrentState.setInspectedCollection(null);
                        label = toDepartment != null ? "\"".concat(currentDepartment.displayName, "\" -> \"").concat(toDepartment.displayName, "\"") : tagName;
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.BigMap, 'COLLECTION_DUPLICATE', label, Date.now() - startTime);
                        return [3 /*break*/, 10];
                    case 9:
                        e_2 = _a.sent();
                        (0, index_1.handleGenericError)(e_2);
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    CollectionService.prototype.assign = function (collectionSummaries, userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uuids, allSelectors, tagIds, startTime, selectorBatches, _i, selectorBatches_2, selectors, label, e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userId = userId == null ? undefined : userId;
                        if (index_1.Services.Department.current == null) {
                            throw new Error('Cannot assign collections without a current department');
                        }
                        uuids = collectionSummaries.map(function (summary) { return summary.uuid; });
                        allSelectors = uuids.map(function (uuid) { return ({ uuid: uuid }); });
                        tagIds = this.getTagIds(collectionSummaries);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, , 9]);
                        startTime = Date.now();
                        selectorBatches = core_shared_1.IkeArray.chunk(allSelectors, CollectionService.BATCH_SIZE);
                        _i = 0, selectorBatches_2 = selectorBatches;
                        _a.label = 2;
                    case 2:
                        if (!(_i < selectorBatches_2.length)) return [3 /*break*/, 5];
                        selectors = selectorBatches_2[_i];
                        return [4 /*yield*/, index_1.Services.Department.rest.Collection.assign({ userId: userId, collections: selectors })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [4 /*yield*/, page_state_1.CurrentState.updateInspectedCollection()];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, this.refresh(uuids)];
                    case 7:
                        _a.sent();
                        label = "Tags: ".concat(tagIds.length, ", Collections: ").concat(collectionSummaries.length);
                        if (userId != null) {
                            index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.BigMap, 'COLLECTION_ASSIGN', label, Date.now() - startTime);
                        }
                        else {
                            index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.BigMap, 'COLLECTION_UNASSIGN', label, Date.now() - startTime);
                        }
                        return [3 /*break*/, 9];
                    case 8:
                        e_3 = _a.sent();
                        (0, index_1.handleGenericError)(e_3);
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    CollectionService.prototype.move = function (collectionSummaries, tagName, targetDepartmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentDepartment, toDepartment, allSelectors, tagIds, startTime, selectorBatches, _i, selectorBatches_3, selectors, label, e_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentDepartment = index_1.Services.Department.current;
                        if (currentDepartment == null) {
                            throw new Error('Cannot move collections without a current department');
                        }
                        if (!(targetDepartmentId != null && targetDepartmentId !== currentDepartment.objectId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, index_1.Services.Department.departments.find(function (d) { return d.objectId === targetDepartmentId; })];
                    case 1:
                        toDepartment = _a.sent();
                        if (toDepartment == null) {
                            throw new Error('Cannot move collections without a destination department');
                        }
                        _a.label = 2;
                    case 2:
                        allSelectors = collectionSummaries.map(function (summary) { return ({ uuid: summary.uuid }); });
                        tagIds = this.getTagIds(collectionSummaries);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 11, , 12]);
                        startTime = Date.now();
                        selectorBatches = core_shared_1.IkeArray.chunk(allSelectors, CollectionService.BATCH_SIZE);
                        _i = 0, selectorBatches_3 = selectorBatches;
                        _a.label = 4;
                    case 4:
                        if (!(_i < selectorBatches_3.length)) return [3 /*break*/, 9];
                        selectors = selectorBatches_3[_i];
                        if (!(targetDepartmentId == null || targetDepartmentId === currentDepartment.objectId)) return [3 /*break*/, 6];
                        return [4 /*yield*/, index_1.Services.Department.rest.Collection.moveToJob({ collections: selectors, tagName: tagName })];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, index_1.Services.Department.rest.Collection.moveToDepartment({ collections: selectors, targetDepartmentId: targetDepartmentId })];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8:
                        _i++;
                        return [3 /*break*/, 4];
                    case 9: return [4 /*yield*/, index_1.Services.Tag.refresh(tagIds)];
                    case 10:
                        _a.sent();
                        page_state_1.CurrentState.Tag.reset();
                        page_state_1.CurrentState.setInspectedCollection(null);
                        store_1.AppStore.TagSummary.clear();
                        label = toDepartment != null ? "\"".concat(currentDepartment.displayName, "\" -> \"").concat(toDepartment.displayName, "\"") : tagName;
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.BigMap, 'COLLECTION_MOVE', label, Date.now() - startTime);
                        return [3 /*break*/, 12];
                    case 11:
                        e_4 = _a.sent();
                        (0, index_1.handleGenericError)(e_4);
                        return [3 /*break*/, 12];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    CollectionService.prototype.save = function (collection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest, collectionJSON, newCollectionJSON;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rest = index_1.Services.Department.rest;
                        collectionJSON = core_shared_1.IkeModel.Collection.write(collection);
                        return [4 /*yield*/, rest.save(rest.Objects.Collection, collectionJSON)];
                    case 1:
                        newCollectionJSON = _a.sent();
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'Collection:save', collection.uuid, 1);
                        return [4 /*yield*/, this.refresh([newCollectionJSON.uuid])];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, store_1.AppStore.Collection.fetch(newCollectionJSON.revision)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, newCollectionJSON];
                }
            });
        });
    };
    CollectionService.prototype.refresh = function (collectionUuids) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collectionSummaries;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(collectionUuids.map(function (uuid) { return store_1.AppStore.CollectionSummary.getFetchableByUuid(uuid).refetch(); }))];
                    case 1:
                        collectionSummaries = _a.sent();
                        return [2 /*return*/, Promise.all(tslib_1.__spreadArray([
                                store_1.AppStore.Tag.refresh()
                            ], this.getTagIds(collectionSummaries).map(function (tagId) { return store_1.AppStore.TagSummary.getFetchable(tagId).refetch(); }), true))];
                }
            });
        });
    };
    CollectionService.prototype.getTagIds = function (collectionSummaries) {
        var tags = {};
        for (var _i = 0, collectionSummaries_1 = collectionSummaries; _i < collectionSummaries_1.length; _i++) {
            var collectionSummary = collectionSummaries_1[_i];
            for (var _a = 0, _b = collectionSummary.tags; _a < _b.length; _a++) {
                var tag = _b[_a];
                if (!tags[tag] && !(0, core_api_1.isSystemTag)(tag)) {
                    tags[tag] = true;
                }
            }
        }
        return Object.keys(tags);
    };
    CollectionService.BATCH_SIZE = 50;
    return CollectionService;
}());
exports.CollectionService = CollectionService;
//# sourceMappingURL=collection.service.js.map